import { useState } from "react";
import type { FileItem } from "../../types";
import { getThumbnailUrl } from "../../utils/fileUtils";
import { FileIcon } from "../shared/FileIcon";

export function ThumbnailCell({
  thumbnailUrl,
  fileType,
  fileName,
}: {
  thumbnailUrl?: string;
  fileType: FileItem["type"];
  fileName: string;
}) {
  const [imageError, setImageError] = useState(false);
  const fullUrl = thumbnailUrl ? getThumbnailUrl(thumbnailUrl) : undefined;

  if (!fullUrl || imageError) {
    return <FileIcon type={fileType} className="h-10 w-10 text-ink-300" />;
  }

  return (
    <img
      src={fullUrl}
      alt={fileName}
      className="h-10 w-10 object-cover rounded"
      onError={() => setImageError(true)}
    />
  );
}
